//action hook
import { useDispatch } from 'react-redux'
import { UtilActionsTypes } from './types'

//interfaces
export interface SetIsPostDispatchI {
	type: UtilActionsTypes.setIsPost
	payload: boolean
}

interface UseUtilActionsI {
	setIsPost: (isPost: boolean) => void
}

export const useUtilActions = (): UseUtilActionsI => {
	const dispatch = useDispatch()

	const setIsPost = (isPost: boolean) => {
		dispatch<SetIsPostDispatchI>({
			type: UtilActionsTypes.setIsPost,
			payload: isPost,
		})
	}

	return {
		setIsPost,
	}
}
